<template>
    <li>
        <div @click="toggle" class="pb-1">
            <div class="d-flex cursor-pointer align-items-center">
                <b-form-checkbox
                    inline
                    :name="item.id + 'e32'"
                    class="mt-0 mr-50"
                    v-model="item.selected"
                    @change="onCheckboxChange"
                />
                <span v-if="item.isComplex" class="align-items-center mr-50">
                    <feather-icon :icon="isOpen ? 'ChevronDownIcon' : 'ChevronRightIcon'" />
                </span>
                <slot name="title" :item="item">
                    {{ item.title }}
                </slot>
            </div>
        </div>
        <Transition name="fade-top-2x">
            <ul v-show="isOpen" v-if="isFolder" class="list-unstyled product-hierarchy">
                <ComponentsTreeItem
                    class="item"
                    v-for="(child, index) in item.children"
                    :key="index"
                    :item="child"
                    @toggle="onToggle"
                    @checked="onChecked"
                    @unchecked="onUnChecked"
                >
                    <template #title="data">
                        <slot name="title" :item="data.item"/>
                    </template>
                </ComponentsTreeItem>
            </ul>
        </Transition>
    </li>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {BFormCheckbox, BButton} from 'bootstrap-vue'

export default {
    directives: {Ripple},
    name: 'ComponentsTreeItem',
    components: {
        BFormCheckbox, BButton
    },
    props: {
        item: {
            type: Object,
            default() {
                return {
                    isOpen: false
                };
            }
        }
    },
    data: function() {
        return {
            isOpen: this.item.isOpen,
            isChecked: this.item.selected
        };
    },
    methods: {
        onChecked(item) {
            this.$emit('checked', item);
        },
        onUnChecked(item) {
            this.$emit('unchecked', item);
        },
        onCheckboxChange(isChecked) {
            this.$emit(isChecked ? 'checked' : 'unchecked', this.item);
        },
        onToggle(item, isOpen) {
            this.$emit('toggle', item, isOpen);
        },
        toggle: function() {
            if (this.isFolder) {
                this.isOpen = !this.isOpen;

                this.$emit('toggle', this.item, this.isOpen);
            }
        },
    },
    computed: {
        selected() {
            return this.item.selected;
        },
        isFolder() {
            return this.item.children && this.item.children.length;
        },
    },
    watch: {
        // selected() {
        //     if (this.isChecked !== this.selected) {
        //         this.isChecked = this.selected;
        //     }
        // },
        item(item) {
            this.isChecked = item.selected;
            this.isOpen = item.isOpen;
        }
    }
}
</script>

<style scoped>

</style>
